import * as React from 'react';
import { withRouter } from 'react-router';

import {
	App as AppBase,
	IAppBaseProps,
} from '@common/App';
import { Error } from '@common/components/Error';

import { AppProviders } from '@components/AppProviders';

import { getRouter, getRoutes } from './Router';

import * as s from './App.scss';

interface IAppProps extends IAppBaseProps {
}

export class AppComponent extends React.Component<IAppProps> {

	render() {
		const Router = getRouter();
		const routes = getRoutes();

		return (
			<AppBase
				{...this.props}
				routes={routes}
				render={({ error }) => {
					return (
						<div className={s.app}>
							<AppProviders>
								{error
									? <Error error={error}/>
									: <Router/>
								}
							</AppProviders>
						</div>
					);
				}}
			/>
		);
	}

}

export const App = withRouter(AppComponent);
